import React, { FC } from "react";
import { useSelector } from "react-redux";
import { Redirect, Route } from "react-router-dom";

interface IProps {
  component: () => JSX.Element;
  exact: boolean;
  path: string;
}

const PrivateRoute: FC<IProps> = ({ component: Component, ...rest }) => {
  //const state = useSelector((state: any) => state);

  //console.log(state);

  const isAuthenticated = useSelector(
    (state: any) =>
      state.authentication.user && !!state.authentication.user.UserId
  );

  /*   const isAuthenticated =
    state.authentication !== null
      ? !!state.authentication.user.UserId
      : localStorage.getItem("User_AccessToken"); */

  //console.log(isAuthenticated);

  return isAuthenticated ? (
    <>
      <Route {...rest} component={(props: any) => <Component {...props} />} />
    </>
  ) : (
    <Redirect to="/login" />
  );
};

export default PrivateRoute;
